import { Serializable } from '@/models/core/serializable';
import { SchoolGroupStudent } from './school-group-student';
import { Tag } from '@/models/tag';
import { GroupType } from '@/constants/groupType.enum';

export class SchoolGroupDetail implements Serializable<SchoolGroupDetail> {
  schoolGroupID: number;
  name: string;
  growingPurpose: number;
  groupType: number;
  memo: string;
  group: SchoolGroupStudent[];
  grade: number;
  schoolClassName: string;
  tags: Tag[];
  schoolCompetencyID: number; // 学校コンピテンシーID

  deserialize(input: any): SchoolGroupDetail {
    this.schoolGroupID = input.schoolGroupID;
    this.name = input.name;
    this.growingPurpose = input.growingPurpose;
    this.groupType = input.groupType;
    this.memo = input.memo;
    this.group = input.group.map((group: SchoolGroupStudent) => new SchoolGroupStudent().deserialize(group));
    this.grade = input.grade;
    this.schoolClassName = input.schoolClassName;
    if (input.tags !== null && input.tags !== undefined) {
      this.tags = input.tags.map((tag: any) => new Tag().deserialize(tag));
    }
    this.schoolCompetencyID = input.schoolCompetencyID;
    return this;
  }

  get groupTypeName(): string {
    return GroupType.groupTypeName(this.groupType);
  }

  get tagContents(): string[] {
    return this.tags.map((tag: Tag) => tag.tagContent);
  }
}
